import { PetNote as Container } from "./styles";

export function PetCardNote({ children }) {
  if (!children) return null;
  return <Container>{children}</Container>;
}
